import { InputDrug } from 'app/shared/models/medispan/input-drug';

export class MediSpanViewModel {
   PatientId: number;
   Drugs: InputDrug[] = [];
   GroupSettingId: number;
}
